import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * FilterAreaView class extends JetView to create a filter area UI.
 */
export default class FilterAreaView extends JetView {
    /**
     * Configures the UI components of the filter area.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with ID input
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span>ID"), // Localized label
                    labelPosition: 'top',
                    placeholder: _('ID'), // Localized placeholder
                },
            ],
        };

        // Center left section with Name input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for Name
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Nombre'), // Localized placeholder
                },
            ],
        };

        // Center right section with Employees combo
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'combo', // Combo box for selecting Employees
                    name: 'Employees',
                    id: 'Employees',
                    label: _('Encargado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
            ],
        };

        // Right section with IsActivate richselect
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Rich select for activation status
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [
                        // Options for the richselect
                        { id: 'null', value: _('Todos') }, // All option
                        { id: 'A', value: _('Activado') }, // Activated option
                        { id: 'I', value: _('Inactivado') }, // Inactivated option
                    ],
                },
            ],
        };

        // Upper section containing the input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of input sections
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button', // Button to add area
                    value: _('Añadir Área'), // Localized button text
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction('accountingAreaAdd', 'Add'), // Permission check
                    css: 'prm-accountingAreaAdd',
                    click: () => {
                        // Click event for adding area
                        this.app.callEvent('addArea:button', [{}]);
                    },
                },
                {
                    view: 'button', // Button to clear inputs
                    value: _('Limpiar'), // Localized button text
                    autowidth: true,
                    click: () => {
                        // Click event for clearing inputs
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Button to consult/filter
                    value: _('Consultar'), // Localized button text
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event for filtering
                        const filterdata = this.getRoot().getValues(); // Get input values
                        this.app.callEvent('area:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and fetches employee data.
     */
    init() {
        webix
            .ajax() // AJAX request to fetch employee data
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Accounting/GetEmployeesSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message(_('Error! ')); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    var resp = JSON.parse(text); // Parse response
                    $$('Employees').define('options', resp.Data); // Define options for Employees combo
                    $$('Employees').refresh(); // Refresh the combo
                },
            });
    }
}

// FILE DOCUMENTED
